import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
export type AnnouncementDTO = {
  id: string;
  title: string;
  message: string;
  isPin: boolean;
  deadline: string;
  createdAt: string;
  updatedAt: string;
  forward_link:string;
  forward_text:string;
};

interface AnnouncementData {
  AnnouncementData: AnnouncementDTO[];
}
interface AnnouncementResponse {
  data?: AnnouncementData;
  error?: ApiError;
}

export const GetAnnouncements = async (): Promise<AnnouncementResponse> => {
  try {
    const response = await axios.get("/announcement/all");
    return { data: { AnnouncementData: response.data } };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
